

















import Vue from 'vue';
import CandidateService from '~/services/CandidateService';
import { CandidateStudyProgram } from '~/services/CSPService';
import {
    CandidateJobBuilder,
    CandidateJobBuilderChangeEvent,
    commonProps,
    setupBuilder,
} from '~/utils/candidate';
import StudyProgramsForm from '../forms/StudyProgramsForm.vue';
import ProfileModal from './ProfileModal.vue';

export default Vue.extend({
    name: 'StudyProgramsModal',
    components: {
        ProfileModal,
        StudyProgramsForm,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        ...commonProps(),
    },
    data() {
        return {
            builder: null as CandidateJobBuilder | null,
            service: new CandidateService(),
            isLoading: false,
            isFormValid: true,
            hasUnsavedChanges: false,
        };
    },
    computed: {
        saveDisabled(): boolean {
            return !this.hasUnsavedChanges || !this.isFormValid;
        },
        programs(): CandidateStudyProgram[] {
            return [...this.candidate.studyPrograms].sort(
                (a, b) => a.start.getTime() - b.start.getTime()
            );
        },
    },
    methods: {
        handleBuilderChange(evt: CandidateJobBuilderChangeEvent) {
            this.hasUnsavedChanges = !evt.empty;
        },
        handleSave() {
            if (!this.builder) return;

            const request = this.builder.buildRequest();
            this.isLoading = true;
            this.service
                .updateCandidateProfile(request)
                .then(() => {
                    this.$emit('close');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
    mounted() {
        const builder = setupBuilder.apply(this);
        builder.on('change', this.handleBuilderChange);
    },
    beforeDestroy() {
        if (this.builder) this.builder.off('change', this.handleBuilderChange);
    },
});
